const CommunityIcon = () => (
  <svg viewBox="0 0 64 64" fill="currentColor" width="100%" height="100%">
    <defs>
      <linearGradient id="tableWood" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#8B5A2B"/>
        <stop offset="50%" stopColor="#6b4423"/>
        <stop offset="100%" stopColor="#4a3020"/>
      </linearGradient>
      <linearGradient id="armorSilver" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#a0a0a0"/>
        <stop offset="30%" stopColor="#808080"/>
        <stop offset="70%" stopColor="#606060"/>
        <stop offset="100%" stopColor="#505050"/>
      </linearGradient>
      <linearGradient id="armorGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#d4a227"/>
        <stop offset="50%" stopColor="#b8860b"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
      <linearGradient id="cloakRed" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#8b2500"/>
        <stop offset="100%" stopColor="#5c1a00"/>
      </linearGradient>
      <linearGradient id="cloakBlue" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#1e4080"/>
        <stop offset="100%" stopColor="#0f2040"/>
      </linearGradient>
      <filter id="knightShadow">
        <feDropShadow dx="1" dy="2" stdDeviation="1" floodOpacity="0.4"/>
      </filter>
    </defs>
    
    {/* Mesa redonda */}
    <ellipse cx="32" cy="52" rx="28" ry="10" fill="#3a2a1a"/>
    <ellipse cx="32" cy="50" rx="26" ry="8" fill="url(#tableWood)"/>
    <ellipse cx="32" cy="50" rx="22" ry="6" fill="#9b6b3b"/>
    <ellipse cx="32" cy="50" rx="18" ry="4" fill="#ab7b4b" opacity="0.5"/>
    
    {/* Ornamento central da mesa */}
    <circle cx="32" cy="50" r="6" fill="#8b6914" stroke="#c9a227" strokeWidth="1"/>
    <circle cx="32" cy="50" r="4" fill="#c9a227"/>
    <path d="M30 48 L32 46 L34 48 L34 52 L32 54 L30 52 Z" fill="#8b6914"/>
    
    {/* Cavaleiro esquerdo (vermelho) */}
    <g transform="translate(4, 16)" filter="url(#knightShadow)">
      {/* Capa */}
      <path d="M6 24 L2 38 L14 38 L10 24 Z" fill="url(#cloakRed)"/>
      
      {/* Capacete */}
      <path d="M8 6 C3 6 1 11 1 16 L1 22 L15 22 L15 16 C15 11 13 6 8 6 Z" fill="url(#armorSilver)"/>
      <path d="M8 4 L8 8" stroke="#c9a227" strokeWidth="2"/>
      <circle cx="8" cy="3" r="2" fill="#c9a227"/>
      
      {/* Viseira */}
      <rect x="3" y="14" width="10" height="5" fill="#404040" rx="1"/>
      <path d="M4 15 L12 15 M4 17 L12 17" stroke="#2a2a2a" strokeWidth="0.8"/>
      
      {/* Armadura do corpo */}
      <path d="M2 22 L2 36 L14 36 L14 22 Z" fill="url(#armorSilver)"/>
      <path d="M4 24 L4 34 L12 34 L12 24 Z" fill="#707070"/>
      <line x1="8" y1="24" x2="8" y2="34" stroke="#505050" strokeWidth="1"/>
      
      {/* Símbolo no peito */}
      <circle cx="8" cy="29" r="3" fill="url(#cloakRed)" stroke="#c9a227" strokeWidth="0.5"/>
    </g>
    
    {/* Cavaleiro direito (azul) */}
    <g transform="translate(44, 16)" filter="url(#knightShadow)">
      {/* Capa */}
      <path d="M6 24 L2 38 L14 38 L10 24 Z" fill="url(#cloakBlue)"/>
      
      {/* Capacete */}
      <path d="M8 6 C3 6 1 11 1 16 L1 22 L15 22 L15 16 C15 11 13 6 8 6 Z" fill="url(#armorSilver)"/>
      <path d="M8 4 L8 8" stroke="#c9a227" strokeWidth="2"/>
      <circle cx="8" cy="3" r="2" fill="#c9a227"/>
      
      {/* Viseira */}
      <rect x="3" y="14" width="10" height="5" fill="#404040" rx="1"/>
      <path d="M4 15 L12 15 M4 17 L12 17" stroke="#2a2a2a" strokeWidth="0.8"/>
      
      {/* Armadura do corpo */}
      <path d="M2 22 L2 36 L14 36 L14 22 Z" fill="url(#armorSilver)"/>
      <path d="M4 24 L4 34 L12 34 L12 24 Z" fill="#707070"/>
      <line x1="8" y1="24" x2="8" y2="34" stroke="#505050" strokeWidth="1"/>
      
      {/* Símbolo no peito */}
      <circle cx="8" cy="29" r="3" fill="url(#cloakBlue)" stroke="#c9a227" strokeWidth="0.5"/>
    </g>
    
    {/* Cavaleiro do meio (dourado/líder) */}
    <g transform="translate(24, 10)" filter="url(#knightShadow)">
      {/* Capa maior */}
      <path d="M8 26 L2 42 L14 42 L8 26 Z" fill="#4a3020"/>
      
      {/* Capacete dourado */}
      <path d="M8 4 C2 4 0 10 0 16 L0 24 L16 24 L16 16 C16 10 14 4 8 4 Z" fill="url(#armorGold)"/>
      
      {/* Coroa/crista */}
      <path d="M8 0 L6 4 L8 2 L10 4 Z" fill="#c9a227"/>
      <path d="M4 3 L6 6" stroke="#c9a227" strokeWidth="1.5"/>
      <path d="M12 3 L10 6" stroke="#c9a227" strokeWidth="1.5"/>
      
      {/* Viseira */}
      <rect x="2" y="14" width="12" height="6" fill="#505050" rx="1"/>
      <path d="M3 15 L13 15 M3 17 L13 17 M3 19 L13 19" stroke="#2a2a2a" strokeWidth="0.6"/>
      
      {/* Armadura do corpo */}
      <path d="M0 24 L0 40 L16 40 L16 24 Z" fill="url(#armorGold)"/>
      <path d="M2 26 L2 38 L14 38 L14 26 Z" fill="#a08020"/>
      <line x1="8" y1="26" x2="8" y2="38" stroke="#8b6914" strokeWidth="1"/>
      
      {/* Símbolo real no peito */}
      <path d="M6 30 L8 28 L10 30 L10 34 L8 36 L6 34 Z" fill="#c9a227" stroke="#8b6914" strokeWidth="0.5"/>
    </g>
    
    {/* Itens na mesa */}
    {/* Cálice esquerdo */}
    <g transform="translate(18, 44)">
      <path d="M2 0 L0 4 L4 4 Z" fill="#c9a227"/>
      <rect x="1" y="4" width="2" height="2" fill="#b8860b"/>
      <ellipse cx="2" cy="6" rx="2" ry="1" fill="#8b6914"/>
    </g>
    
    {/* Cálice direito */}
    <g transform="translate(40, 44)">
      <path d="M2 0 L0 4 L4 4 Z" fill="#c9a227"/>
      <rect x="1" y="4" width="2" height="2" fill="#b8860b"/>
      <ellipse cx="2" cy="6" rx="2" ry="1" fill="#8b6914"/>
    </g>
    
    {/* Pergaminho no centro */}
    <g transform="translate(28, 46)">
      <rect x="0" y="0" width="8" height="5" fill="#f5deb3" rx="0.5"/>
      <ellipse cx="0" cy="2.5" rx="1" ry="2.5" fill="#c9a067"/>
      <ellipse cx="8" cy="2.5" rx="1" ry="2.5" fill="#c9a067"/>
    </g>
  </svg>
)

export default CommunityIcon
